export function stripCountrySuffix(address: string): string {
  let value = address.trim();
  const lower = value.toLowerCase();

  for (const suffix of [', united states', ', usa', ', us']) {
    if (lower.endsWith(suffix)) {
      value = value.slice(0, -suffix.length).trim();
      break;
    }
  }

  return value;
}

export function toAddressQueryParam(address: string): string {
  return stripCountrySuffix(address)
    .toLowerCase()
    .replace(/,/g, ' ')
    .replace(/\./g, ' ')
    .replace(/\s+/g, ' ')
    .trim()
    .split(' ')
    .join('+');
}

export function fromAddressQueryParam(param: string): string {
  return param.replace(/\+/g, ' ').replace(/\s+/g, ' ').trim();
}

export function splitAddressLines(address: string): { lineOne: string; lineTwo: string } {
  const normalized = fromAddressQueryParam(address).toLowerCase();
  const laredoIndex = normalized.indexOf('laredo');

  if (laredoIndex === -1) {
    const parts = fromAddressQueryParam(address).split(',').map(part => part.trim()).filter(Boolean);
    if (parts.length >= 2) {
      return {
        lineOne: parts[0],
        lineTwo: parts.slice(1).join(', '),
      };
    }

    return {
      lineOne: fromAddressQueryParam(address),
      lineTwo: '',
    };
  }

  return {
    lineOne: normalized.substring(0, laredoIndex).trim(),
    lineTwo: normalized
      .substring(laredoIndex)
      .replace('laredo', 'Laredo')
      .replace(' tx', ', TX'),
  };
}
